import React, { useState } from 'react';
import { FaFacebookF } from "react-icons/fa";
import ChatWidget from "./ChatWidget";
import ChatButton from "./ChatButton";
import LanguageSwitcher from "./LanguageSwitcher";

const CONTENT = {
  en: {
    copyright: "© Commercial Cleaning - All rights reserved",
  },
  es: {
    copyright: "© Limpieza comercial - Todos los derechos reservados",
  },
};

const Footer = ({ lang = "en" }) => {
  const [chatOpen, setChatOpen] = useState(false);
  const t = CONTENT[lang] || CONTENT.en;

  return (
    <footer>
      <div>
        <div className="bg-[#DBE4E5]">
   <div className="flex items-center justify-between max-w-5xl m-auto py-4 px-4">
  <span className="text-[#1465B7] text-base font-semibold">
    {t.copyright}
  </span>

  <div className="flex items-center gap-3">
    <LanguageSwitcher />
    <a
      href="https://www.facebook.com/profile.php?id=61582707424269"
      target="_blank"
      rel="noopener noreferrer"
      className="group"
    >
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#1877F2] shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-110 active:scale-95">
        <FaFacebookF size={20} className="text-white" />
      </div>
    </a>
    <ChatButton onClick={() => setChatOpen(true)} />
  </div>
</div>
</div>
      </div>
      <ChatWidget onOpenChange={setChatOpen} isExternallyOpened={chatOpen} />
    </footer>
  );
};

export default Footer;
